export default {"src":"/_next/static/media/copy_icon.62c457df.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};